import { useContext, useEffect } from 'react';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext
} from '../../WorkflowEngine/workflowEngineReducer';
import PageState from '../../Shared/pageState';
import { v4 as uuidv4 } from 'uuid';
import { useSnackbar } from 'notistack';
import ControlState from '../../Shared/controlState';
import ControlKind from '../../Shared/controlKind';
import isBuilding from '../../Shared/jsonSchemaUtilities/isBuilding';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Signature as SignatureIcon } from '@abbott-components/icons';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { DragTypes } from '../../DragAndDrop';
import getLatestSchema from './schema';
import Tooltip from '@mui/material/Tooltip';

export default () => {
  const { state, dispatch } = useContext(WorkflowEngineContext);

  const { pages } = state;

  const { enqueueSnackbar } = useSnackbar();

  const handleSignatureClick = () => {
    if (isBuilding(state.pages)) {
      enqueueSnackbar('One control can be built at a time.', {
        variant: 'warning'
      });
      return;
    }

    const lastPage = pages[pages.length - 1] as PageState;

    const controlId = `control-${uuidv4()}`;
    const pageExternalId = lastPage.id;
    const order = Object.keys(lastPage.schema.properties as object).length - 1;

    const controlSchema = getLatestSchema(controlId, pageExternalId, order);

    dispatch({
      type: WorkflowEngineActionKind.CONTROL_ADD,
      payload: {
        id: controlId,
        building: true,
        pageId: lastPage.id,
        schema: controlSchema,
        kind: ControlKind.SIGNATURE
      } as ControlState
    });
  };

  const [, drag, preview] = useDrag(
    () => ({
      type: DragTypes.PALETTE_CONTROL,
      item: { type: ControlKind.SIGNATURE }
    }),
    []
  );

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return (
      <Tooltip title="Signature" placement="right" disableInteractive>
    <ListItemButton onClick={handleSignatureClick} ref={drag}>
      <ListItemIcon style={{ minWidth: 'auto' }}>
        <SignatureIcon />
      </ListItemIcon>
    </ListItemButton>
    </Tooltip>
  );
};
